'use strict';

var Sugar = require('sugar-core'),
    average = require('../enumerable/internal/average');

Sugar.Object.defineInstanceAndStatic({

  'average': function(obj, map) {
    return average(obj, map);
  }

});

module.exports = Sugar.Object.average;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/average.js
// module id = 768
// module chunks = 0